import { For, Show, type JSX } from 'solid-js'
import type { IndicatorScope } from 'mormaii-web-presentation/status-bands'
import Css from './status-bands.module.scss'
import { Band } from './band'
import { WarningIcon } from './warning-icon'

/** Um indicador: o nome com a unidade ao lado, e as quatro faixas dele. */
export function Indicator(props: { scope: IndicatorScope }): JSX.Element {
    return (
        <section class={Css.metric}>
            <p class={Css.metricTitle}>
                {props.scope.label}
                {/*
                    A unidade ja vinha no scope e o painel antigo nunca a desenhou.
                    Sem ela nada na tela diz que "37.8" e um grau e "140" e um
                    milimetro de mercurio.
                */}
                <Show when={props.scope.unit}>{(unit) => <span class={Css.unit}>{unit()}</span>}</Show>

                {/*
                    O aviso ao lado do PARAMETRO.

                    A faixa defeituosa ja tinha o seu icone e o rodape ja listava tudo
                    por extenso; faltava a altura do meio. Com sete indicadores abertos,
                    saber QUAL deles tem vao exigia percorrer as vinte e oito faixas.
                */}
                <Show when={props.scope.warning}>
                    {(aviso) => (
                        <span class={Css.metricProblem} title={aviso()} aria-label={aviso()}>
                            <WarningIcon />
                        </span>
                    )}
                </Show>
            </p>

            <div class={Css.bands}>
                <For each={props.scope.bands}>{(band) => <Band scope={band} />}</For>
            </div>
        </section>
    )
}
